import { render, staticRenderFns } from "./RuleHistorical.vue?vue&type=template&id=6587265f&scoped=true"
import script from "./RuleHistorical.vue?vue&type=script&lang=js"
export * from "./RuleHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6587265f",
  null
  
)

export default component.exports